import { Gender } from "api/src/users/enum/gender";

export const GENDERS = [
  { label: "Male", value: Gender.male },
  { label: "Female", value: Gender.female },
  { label: "Other", value: Gender.other },
];
